import { combineReducers } from 'redux';
import contactNoteReducer from 'reducers/contactNoteReducer';
import resourceReducer from 'reducers/resourceReducer';
import userReducer from 'reducers/userReducer';
import contactNoteListReducer from 'reducers/contactNoteListReducer';
import modalReducer from 'reducers/modalReducer';
import thunk from 'redux-thunk';
import { configureStore } from '@reduxjs/toolkit';

const reducer = combineReducers({
  contactNotes: contactNoteReducer,
  resources: resourceReducer,
  user: userReducer,
  contactNoteList: contactNoteListReducer,
  modal: modalReducer,
});

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({
      serializableCheck: false,
    }),
    thunk,
  ],
});

export default store;
export type AppDispatch = typeof store.dispatch;
